<!-- ============================================================================
     ObjectComponent template for ch.ChInboundSourceConfig (Complex Config Entity).
     Three left-navigation sections, each a child table widget filtered by the
     selected parent source config:
       - WhatsApp-Nummern   : ch.ChWhatsappNumberConfig
       - Postfächer         : ch.ChMailboxConfig
       - SMS-Konfiguration  : ch.ChSmsConfig
     Child create defaults + read-only the inboundSourceConfig FK (CONFIG-012).
     @ticket TM-1000001922
     ============================================================================ -->
@if (initialized && dto) {

    <!-- ==================== Section: WhatsApp-Nummern ==================== -->
    @if (activeNavigationItems?.action == 'whatsappNumbers') {
        <div class="p-3">
            <p-message severity="info"
                       text="Verify-Token, App-Secret und Access-Token werden verschlüsselt gespeichert und nach dem Speichern nicht mehr angezeigt."
                       styleClass="w-full mb-2">
            </p-message>
            @if (whatsappNumbersWidget) {
                <mvs-widget [widgetData]="whatsappNumbersWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Section: Postfächer ==================== -->
    @if (activeNavigationItems?.action == 'mailboxes') {
        <div class="p-3">
            <p-message severity="info"
                       text="Delta-Token und letzte Synchronisierung werden vom System gepflegt und sind nicht editierbar."
                       styleClass="w-full mb-2">
            </p-message>
            @if (mailboxesWidget) {
                <mvs-widget [widgetData]="mailboxesWidget"></mvs-widget>
            }
        </div>
    }

    <!-- ==================== Section: SMS-Konfiguration ==================== -->
    @if (activeNavigationItems?.action == 'smsConfigs') {
        <div class="p-3">
            <p-message severity="info"
                       text="Das Webhook-Secret wird verschlüsselt gespeichert und nach dem Speichern nicht mehr angezeigt."
                       styleClass="w-full mb-2">
            </p-message>
            @if (smsConfigsWidget) {
                <mvs-widget [widgetData]="smsConfigsWidget"></mvs-widget>
            }
        </div>
    }

}
